import React from 'react'
import { CalendarIcon } from 'lucide-react'

import { DateFormat } from '@/components/date-format.tsx'
import { Empty } from '@/components/empty.tsx'
import { CalendarEvent } from '@/features/calendar/types.ts'
import { EventComponent } from '@/routes/_authenticated/calendar/-components/event-component.tsx'

type ScheduleViewProps = {
  currentDate: Date
  events?: CalendarEvent[]
  isLoading?: boolean
}

export const ScheduleView: React.FC<ScheduleViewProps> = ({
  events,
  isLoading,
}) => {
  if (!isLoading && !events?.length)
    return <Empty title="Nessun evento imminente" />

  return (
    <ol className="mt-4 divide-y divide-gray-100 text-sm/6 lg:col-span-7 xl:col-span-8">
      {events?.map((event) => (
        <li
          key={event.id}
          className="relative flex cursor-pointer items-center space-x-6 py-6 xl:static"
        >
          <div className="flex items-start space-x-3">
            <dt className="mt-0.5">
              <span className="sr-only">Date</span>
              <CalendarIcon
                className="size-5 text-gray-400"
                aria-hidden="true"
              />
            </dt>
            <dd>
              <DateFormat date={event.start_date} format="DD MMM YYYY" />
            </dd>
          </div>

          <div className="flex-auto">
            <EventComponent event={event}>
              <h3 className="pr-10 font-semibold text-gray-900 xl:pr-0">
                {event.title}
              </h3>
            </EventComponent>
          </div>
        </li>
      ))}
    </ol>
  )
}
